import React from "react";
import { Reveal } from "../Reveal";
import { useLang } from "../../i18n/LanguageContext";
import { images } from "../../content/siteConfig";

export const GlobalOutlook = () => {
  const { t } = useLang();
  return (
    <section className="bg-[#061A26] relative overflow-hidden" data-testid="home-global">
      <div className="max-w-[1320px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-2 items-center">
        <Reveal className="py-28 md:py-36 lg:pr-16">
          <p className="eyebrow">{t.global.eyebrow}</p>
          <h2 className="mt-5 text-3xl md:text-4xl font-light tracking-tight text-white leading-[1.15]">
            {t.global.title}
          </h2>
          <p className="mt-6 text-base text-slate-400 leading-relaxed max-w-md">{t.global.copy}</p>
        </Reveal>
        <Reveal delay={0.2} className="relative h-72 lg:h-full min-h-[300px]">
          <img
            src={images.globe}
            alt=""
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover opacity-90"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#061A26] via-transparent to-transparent hidden lg:block" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#061A26] via-transparent to-[#061A26]/40 lg:hidden" />
        </Reveal>
      </div>
    </section>
  );
};
